import {ChangeDetectionStrategy, Component, Injectable, input, Signal} from "@angular/core";
import {AgendaelementId, BeslutningModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable, switchMap} from "rxjs";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {BeslutninglisteKompaktKomponent} from "../../../beslutning/komponenter/beslutningliste-kompakt/beslutningliste-kompakt";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {map} from "rxjs/operators";
import {beslutningsforslag, endeligeBeslutninger} from "felles-ng2/modell/beslutningModellHjelpere";

const debug = initDebugger('SakListeBeslutningerKomponent');

/**
 * Lister beslutninger knyttet til sak
 */
@Component({
    selector: 'sak-liste-beslutninger',
    host: {'data-testid': 'sak-liste-beslutninger'},
    templateUrl: 'sak-liste-beslutninger.html',
    styleUrl: 'sak-liste-beslutninger.scss',
    imports: [
        BeslutninglisteKompaktKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakListeBeslutningerKomponent {
    static ajsSelector = 'sakListeBeslutninger';

    sakId = input.required<AgendaelementId>();
    /** Dersom sann vises forslag, ellers vis endelige beslutninger */
    visKunForslag = input(false);

    beslutninger: Signal<BeslutningModell[]>;

    constructor(private avhengigheter: SakListeBeslutningerKomponentAvhengigheter) {
        this.beslutninger = toSignal(toObservable(this.sakId)
            .pipe(
              switchMap(id => this.avhengigheter.beslutninger(id)),
              map(beslutninger => this.visKunForslag() ? beslutningsforslag(beslutninger) : endeligeBeslutninger(beslutninger)),
              takeUntilDestroyed()),
          {initialValue: []});
    }
}

@Injectable()
export class SakListeBeslutningerKomponentAvhengigheter {

    constructor(private beslutningDatatjeneste: BeslutningDatatjeneste) {
    }

    beslutninger(id: AgendaelementId): Observable<BeslutningModell[]> {
        return this.beslutningDatatjeneste.finnTilknyttetSakFraLokallager(id);
    }
}
